/* Products that remain available in the catalogue but should not be promoted
   in the home-page hero carousel. Package IDs are stable even when Tebex copy
   or generated slugs change. */
const HERO_EXCLUDED_PACKAGE_IDS = new Set([
  7520249 // Complete Banking & Billing System
]);

export const isHeroProduct = (product) => (
  Boolean(product?.thumbnail)
  && !HERO_EXCLUDED_PACKAGE_IDS.has(Number(product?.tebexPackageId || product?.id))
);

/* Interleave categories so consecutive cards belong to different moods —
   otherwise the backdrop barely moves and the effect is invisible. */
export const buildHeroSlides = (allProducts = []) => {
  const withArt = allProducts.filter(isHeroProduct);
  const byCategory = new Map();

  withArt.forEach((product) => {
    const key = String(product.category || 'other').toLowerCase();
    if (!byCategory.has(key)) byCategory.set(key, []);
    byCategory.get(key).push(product);
  });

  const buckets = [...byCategory.values()];
  const interleaved = [];
  for (
    let round = 0;
    interleaved.length < withArt.length && buckets.some((bucket) => bucket[round]);
    round += 1
  ) {
    buckets.forEach((bucket) => {
      if (bucket[round]) interleaved.push(bucket[round]);
    });
  }

  return interleaved.length >= 3 ? interleaved : withArt;
};